/**
 * Creates an in-memory storage mechanism with the same API as session storage and local storage.
 * Exports two instances: session and local.
 */
class InMemoryStorage {
  store = {};
  length = 0;

  setItem(key, value) {
    if (typeof value === 'undefined') {
      this.removeItem(key);
    } else {
      if (!this.store.hasOwnProperty(key)) {
        this.length++;
      }

      this.store[key] = '' + value;
    }
  }

  getItem(key) {
    return this.store[key] || null;
  }

  removeItem(key) {
    /* istanbul ignore else  */
    if (this.store.hasOwnProperty(key)) {
      delete this.store[key];
      this.length--;
    }
  }

  key(index) {
    return Object.keys(this.store)[index] || null;
  }

  clear() {
    this.store = {};
    this.length = 0;
  }
}

const local = new InMemoryStorage();
const session = new InMemoryStorage();

export { local, session };



// WEBPACK FOOTER //
// ./src/utils/InMemoryStorage.js